<template>
  <b-row>
    <b-col cols="12">
      <pop-products-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import PopProductsTable from './PopProductsTable.vue'

export default {
  components: {
    BRow,
    BCol,
    PopProductsTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>